import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Download = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M7 36C7 35.4477 7.44772 35 8 35L32 35C32.5523 35 33 35.4477 33 36C33 36.5523 32.5523 37 32 37L8 37C7.44772 37 7 36.5523 7 36ZM8.29289 19.2929C8.68342 18.9024 9.31658 18.9024 9.70711 19.2929L19 28.5858L19 4C19 3.44772 19.4477 3 20 3C20.5523 3 21 3.44772 21 4L21 28.5858L30.2929 19.2929C30.6834 18.9024 31.3166 18.9024 31.7071 19.2929C32.0976 19.6834 32.0976 20.3166 31.7071 20.7071L20.7071 31.7071C20.5196 31.8946 20.2652 32 20 32C19.7348 32 19.4804 31.8946 19.2929 31.7071L8.29289 20.7071C7.90237 20.3166 7.90237 19.6834 8.29289 19.2929Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Download;
